import React, { useState } from 'react';

const WHATSAPP_NUMBER = '919289228555';
const DEFAULT_MESSAGE = 'Hello Jiyo Life, I would like to inquire about booking.';

function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <div
      className="whatsapp-float-container"
      style={{
        position: 'fixed',
        bottom: '26px',
        left: '26px',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <style>{`
        .whatsapp-float-btn {
          width: 58px;
          height: 58px;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: #ffffff !important;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 18px rgba(37, 211, 102, 0.45), 0 2px 8px rgba(0, 0, 0, 0.18);
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          text-decoration: none;
          cursor: pointer;
          position: relative;
        }
        .whatsapp-float-btn:hover {
          transform: scale(1.08) translateY(-2px);
          box-shadow: 0 8px 24px rgba(37, 211, 102, 0.6), 0 4px 12px rgba(0, 0, 0, 0.22);
          color: #ffffff !important;
        }
        .whatsapp-float-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 50%;
          background: #25D366;
          opacity: 0.5;
          z-index: -1;
          animation: waRadarPulse 2.4s infinite cubic-bezier(0.25, 0, 0, 1);
        }
        @keyframes waRadarPulse {
          0% {
            transform: scale(1);
            opacity: 0.55;
          }
          70% {
            transform: scale(1.45);
            opacity: 0;
          }
          100% {
            transform: scale(1.45);
            opacity: 0;
          }
        }
        .whatsapp-tooltip {
          background: #111827;
          color: #ffffff;
          padding: 8px 14px;
          border-radius: 24px;
          font-size: 13px;
          font-weight: 600;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
          white-space: nowrap;
          pointer-events: none;
          animation: waTooltipIn 0.2s ease forwards;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .whatsapp-online-dot {
          width: 8px;
          height: 8px;
          background-color: #25D366;
          border-radius: 50%;
          display: inline-block;
          box-shadow: 0 0 6px #25D366;
        }
        @keyframes waTooltipIn {
          from { opacity: 0; transform: translateX(-10px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @media (max-width: 768px) {
          .whatsapp-float-container {
            bottom: 20px !important;
            left: 16px !important;
          }
          .whatsapp-float-btn {
            width: 50px !important;
            height: 50px !important;
          }
          .whatsapp-float-btn svg {
            width: 28px !important;
            height: 28px !important;
          }
          .whatsapp-tooltip {
            display: none !important;
          }
        }
      `}</style>

      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-btn"
        aria-label="Chat on WhatsApp with Jiyo Life"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="0"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#ffffff"
            d="M17.472 14.382c-.301-.15-1.782-.879-2.058-.979-.276-.1-.477-.15-.678.15-.2.301-.778.979-.954 1.18-.176.2-.351.226-.653.075s-1.272-.469-2.423-1.496c-.896-.799-1.501-1.786-1.677-2.087-.176-.301-.019-.464.132-.614.136-.135.301-.351.452-.527.151-.176.201-.301.301-.502.1-.2.05-.376-.025-.527-.075-.15-.678-1.633-.929-2.235-.244-.587-.492-.507-.678-.517-.176-.009-.377-.011-.578-.011s-.527.075-.803.376c-.276.301-1.054 1.03-1.054 2.511s1.079 2.912 1.23 3.113c.151.201 2.124 3.243 5.145 4.549.719.311 1.28.497 1.717.636.722.23 1.378.197 1.898.12.579-.087 1.782-.728 2.033-1.431.251-.703.251-1.306.176-1.431-.075-.126-.276-.201-.577-.351z"
          />
          <path
            fill="#ffffff"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.05 21.64a.75.75 0 00.912.912l4.558-1.385A9.957 9.957 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm-8.5 10c0-4.694 3.806-8.5 8.5-8.5s8.5 3.806 8.5 8.5-3.806 8.5-8.5 8.5a8.46 8.46 0 01-4.425-1.246.75.75 0 00-.594-.083l-3.328 1.011 1.025-3.372a.75.75 0 00-.087-.6A8.46 8.46 0 013.5 12z"
          />
        </svg>
      </a>

      {isHovered && (
        <div className="whatsapp-tooltip">
          <span className="whatsapp-online-dot"></span>
          Need Help? Chat on WhatsApp
        </div>
      )}
    </div>
  );
}

export default WhatsAppButton;
